import { useMemo } from 'react'

// eslint-disable-next-line import/no-unresolved
import data from '@albacross/static-data/lib/data/countries.json'

const filterCountry = search => country => new RegExp(search, 'i').test(country.printableName)

const getCountries = (search = '') => {
  if (!search) return data
  return data.filter(filterCountry(search))
}

export const useCountries = (search = '') => {
  const countries = useMemo(() => getCountries(search), [search])

  const countryOptions = useMemo(
    () => countries.map(country => ({ value: country.iso, label: country.printableName })),
    [countries],
  )

  return {
    countries,
    countryOptions,
    areCountriesLoading: false,
  }
}
